import Path from "@core/FileProvider/Path/Path";
import assert from "assert";
import { MCP_PROMPT_MAP } from "../../prompts/mcpPromptMap";
import type { ToolExecutionContext } from "../tool";

export type ResourceTools = Pick<ToolExecutionContext, "app" | "ctx" | "commands">;

const LINK_SYNTAX_CHARS = /[#<>]/g;

export async function saveArticleResource(
	{ ctx, commands }: ResourceTools,
	data: Uint8Array,
	fileName: string,
	catalogName: string,
	articlePath: Path,
	keepFormat: boolean,
): Promise<string> {
	const setCmd = commands.article.resource.set;
	const args = setCmd.params(
		ctx,
		{
			src: `./${fileName.replace(LINK_SYNTAX_CHARS, "_")}`,
			articlePath: articlePath.value,
			catalogName,
			force: "false",
			keepFormat: String(keepFormat),
		},
		{ data: Buffer.from(data) },
	);
	const res = (await setCmd.do(args)) as { path?: string } | undefined;
	return `./${new Path(res?.path ?? fileName).nameWithExtension}`;
}

export async function saveAttachmentAsResource(
	tools: ResourceTools,
	sessionId: string,
	storagePath: string,
	catalogName: string,
	articlePath: Path,
): Promise<string> {
	const attachment = await tools.app.agentManager.attachments.read(sessionId, storagePath);
	assert(attachment, MCP_PROMPT_MAP.fileAddress.missing);
	assert(new Path(attachment.filename).extension?.toLowerCase() !== "md", MCP_PROMPT_MAP.saveChatAttachment.markdown);
	return saveArticleResource(tools, attachment.bytes, attachment.filename, catalogName, articlePath, false);
}
